export const initialState = {
  items: [],
  isFetching: false,
}

export const setCollections = (state, payload) => (
  { ...state, items: payload, isFetching: false }
)

export const setFetching = (state, payload) => (
  { ...state, isFetching: payload }
)
